// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3aFO8","content":"Consent_content__3lF1V","footer":"Consent_footer__gz_z5"};